module.exports = __webpack_public_path__ + "img/NP5.fd6b9ed9.jpeg";